<script lang="ts" setup>
import { HealthState, type MonitoringState } from 'gpcore-grpc/gpcore/type/v1/monitoring_pb';
import { computed } from 'vue';
import { GpTooltip } from '@gportal/uikit';
import Status from './Component.Status.vue';
import useDateFormat from '../composables/useDateFormat';

const props = defineProps<{
  state?: MonitoringState | undefined;
}>();
const format = useDateFormat();

const tooltipContent = computed(() => {
  if (props.state?.updatedAt) {
    return `Last updated: ${format(props.state.updatedAt)}`;
  }

  return 'No monitoring data available yet';
});

const hasAlarm = computed(() => {
  return (
    props.state?.components.filter(
      (component) =>
        component.heathState === HealthState.WARNING ||
        component.heathState === HealthState.CRITICAL,
    ).length > 0
  );
});
</script>

<template>
  <GpTooltip placement="top" :content="tooltipContent">
    <template v-if="!state">
      <Status state="info" label="-" />
    </template>
    <template v-else-if="hasAlarm">
      <Status state="warning" label="Warning" />
    </template>
    <template v-else>
      <Status state="success" label="Healthy" />
    </template>
  </GpTooltip>
</template>
